import DPR from "./DPR";
import DragToolManager from "./DragToolManager";

export default class DragToolUsable {
  constructor(target, buttons, onStartDraw, onStartMove, onStartEyedropper, onFinally) {
    this._usingDragTool = null;

    target.addEventListener('mousedown', e => {
      if(!this._usingDragTool) {
        this._usingDragButton = e.button;
        const x = DPR.mul(e.x);
        const y = DPR.mul(e.y);
        switch(buttons[e.button]) {
          case 'draw':
            this._usingDragTool = onStartDraw(x, y);
            break;
          case 'move':
            this._usingDragTool = onStartMove(x, y);
            break;
          case 'eyedropper':
            this._usingDragTool = onStartEyedropper(x, y);
            break;
        }
      }
    });
    window.addEventListener('mousedown', e => {
      if(this._usingDragTool && e.button !== this._usingDragButton) {
        this._usingDragTool.cancel();
        this._usingDragTool = null;
        onFinally();
      }
      if(e.button === 1) e.preventDefault();  // ブラウザのデフォルトの移動カーソルを禁止
    });
    window.addEventListener('mousemove', e => {
      if(this._usingDragTool) {
        if(e.buttons & DragToolManager.MOUSE_BUTTONS_BITFLAGS[this._usingDragButton]) {
          const x = DPR.mul(e.x);
          const y = DPR.mul(e.y);
          this._usingDragTool.drag(x, y);
        } else {
          this._usingDragTool.cancel();
          this._usingDragTool = null;
        }
      }
    });
    window.addEventListener('mouseup', e => {
      if(this._usingDragTool) {
        if(e.button === this._usingDragButton) {
          this._usingDragTool.finish();
          this._usingDragTool = null;
          onFinally();
        }
      }
    });
  }
  isUsing() {
    return this._usingDragTool != null;
  }
}